// extracted by mini-css-extract-plugin
export default {"root":"jZJavDGl5tuDrrGecsA_","add-quota":"BUisoa9bm0faK4pqhatI","addQuota":"BUisoa9bm0faK4pqhatI","divider":"g_TTgLxg245r984eLJUc"};